var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-bank-account-1783867 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2799 12.9599H2.7199C2.5439 12.9599 2.3999 12.8159 2.3999 12.6399V11.1999C2.3999 11.0239 2.5439 10.8799 2.7199 10.8799H13.2799C13.4559 10.8799 13.5999 11.0239 13.5999 11.1999V12.6399C13.5999 12.8159 13.4559 12.9599 13.2799 12.9599ZM3.0399 12.3199H12.9599V11.5199H3.0399V12.3199Z",
    fill: "#FF754C",
    stroke: "#FF754C",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.0801 14.3998H1.9201C1.7441 14.3998 1.6001 14.2558 1.6001 14.0798V12.6398C1.6001 12.4638 1.7441 12.3198 1.9201 12.3198H14.0801C14.2561 12.3198 14.4001 12.4638 14.4001 12.6398V14.0798C14.4001 14.2558 14.2561 14.3998 14.0801 14.3998ZM2.2401 13.7598H13.7601V12.9598H2.2401V13.7598Z",
    fill: "#FF754C",
    stroke: "#FF754C",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.84002 10.3998C3.66402 10.3998 3.52002 10.2558 3.52002 10.0798V5.59979C3.52002 5.42379 3.66402 5.27979 3.84002 5.27979C4.01602 5.27979 4.16002 5.42379 4.16002 5.59979V10.0798C4.16002 10.2558 4.01602 10.3998 3.84002 10.3998Z",
    fill: "#FF754C",
    stroke: "#FF754C",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.9201 10.3998C5.7441 10.3998 5.6001 10.2558 5.6001 10.0798V5.59979C5.6001 5.42379 5.7441 5.27979 5.9201 5.27979C6.0961 5.27979 6.2401 5.42379 6.2401 5.59979V10.0798C6.2401 10.2558 6.0961 10.3998 5.9201 10.3998Z",
    fill: "#FF754C",
    stroke: "#FF754C",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.0798 10.3998C9.90377 10.3998 9.75977 10.2558 9.75977 10.0798V5.59979C9.75977 5.42379 9.90377 5.27979 10.0798 5.27979C10.2558 5.27979 10.3998 5.42379 10.3998 5.59979V10.0798C10.3998 10.2558 10.2558 10.3998 10.0798 10.3998Z",
    fill: "#FF754C",
    stroke: "#FF754C",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.1598 10.3998C11.9838 10.3998 11.8398 10.2558 11.8398 10.0798V5.59979C11.8398 5.42379 11.9838 5.27979 12.1598 5.27979C12.3358 5.27979 12.4798 5.42379 12.4798 5.59979V10.0798C12.4798 10.2558 12.3358 10.3998 12.1598 10.3998Z",
    fill: "#FF754C",
    stroke: "#FF754C",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.4402 5.91979H2.56023C2.38423 5.91979 2.24023 5.77578 2.24023 5.59978V4.89579C2.24023 4.78379 2.30423 4.68778 2.40023 4.62379L7.84023 1.32779C7.93623 1.26379 8.06423 1.26379 8.17623 1.32779L13.6162 4.62379C13.7122 4.68778 13.7762 4.78379 13.7762 4.89579V5.59978C13.7602 5.77578 13.6162 5.91979 13.4402 5.91979ZM2.88023 5.27979H13.1202V5.07179L8.00023 1.96779L2.88023 5.07179V5.27979Z",
    fill: "#FF754C",
    stroke: "#FF754C",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingbank);
export default __webpack_public_path__ + "static/media/pendingbank.c849e532083b75a2a061803bc6d73c9e.svg";
export { ForwardRef as ReactComponent };